import { type ConfirmState } from "./state";

export const initialState: ConfirmState = {
  isConfirming: false,
  isConfirmed: false,
  errorMessage: "",
};
